import { postRouterUpgrade } from '../spaVersionReleaseCheck'

export const CHUNK_RELOAD_ATTEMPTS_KEY = 'contxt_chunk_auto_reload_attempts'

const MAX_AUTO_RELOAD_ATTEMPTS = 2

/**
 * Clears auto-reload attempt counter after a successful app bootstrap.
 */
export const clearChunkReloadAttempts = () => {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_ATTEMPTS_KEY)
  } catch {
    // sessionStorage may be unavailable
  }
}

/**
 * Dev-only query flags used to preview the error boundary UI (skip auto reload).
 */
export const isDevErrorBoundaryPreview = () => {
  if (!import.meta.env.DEV) {
    return false
  }
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.has('previewChunkError') || searchParams.has('eb')
}

const getChunkReloadAttemptCount = () => {
  try {
    const raw = sessionStorage.getItem(CHUNK_RELOAD_ATTEMPTS_KEY)
    const parsed = Number.parseInt(String(raw ?? '0'), 10)
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0
  } catch {
    return 0
  }
}

/**
 * Whether another automatic reload should run for this chunk failure.
 */
export const canAttemptChunkAutoReload = () => {
  if (isDevErrorBoundaryPreview()) {
    return false
  }
  return getChunkReloadAttemptCount() < MAX_AUTO_RELOAD_ATTEMPTS
}

/**
 * Increments attempt counter, upgrades SPA version cookie, then reloads.
 * Call only when {@link canAttemptChunkAutoReload} is true.
 */
export const performChunkAutoReload = () => {
  try {
    const nextAttempt = getChunkReloadAttemptCount() + 1
    sessionStorage.setItem(CHUNK_RELOAD_ATTEMPTS_KEY, String(nextAttempt))
  } catch {
    // continue with reload even if sessionStorage fails
  }

  void (async () => {
    try {
      await postRouterUpgrade()
    } catch (upgradeError) {
      console.warn(
        '[ErrorBoundary] Failed to upgrade router cookie before auto reload',
        upgradeError,
      )
    }
    window.location.reload()
  })()
}
